<template>
    <div class="vx-row jrb" oncontextmenu="return false">
    <left-preview-slider v-if="isShowComment" v-on:click="isOpenPreview = $event"></left-preview-slider>
      <Transition name="baikei-transition">
        <div class="vx-col md:w-1/3 mb-base" v-if="(jrb == 'jrb-01' && isOpenPreview && isShowComment)" >
          <vx-card :title="jrb" >
            <img src="@/assets/images/jusetsu/screen-edit/jrb/M007-09/M007-09_jrb-01.jpg" width="100%" />
          </vx-card>
        </div>
        <div class="vx-col md:w-1/3 mb-base" v-if="(jrb == 'jrb-02' && isOpenPreview && isShowComment)" >
          <vx-card :title="jrb" >
            <img src="@/assets/images/jusetsu/screen-edit/jrb/M007-09/M007-09_jrb-02.jpg" width="100%" />
          </vx-card>
        </div>
        <div class="vx-col md:w-1/3 mb-base" v-if="(jrb == 'jrb-03' && isOpenPreview && isShowComment)" >
          <vx-card :title="jrb" >
            <img src="@/assets/images/jusetsu/screen-edit/jrb/M007-09/M007-09_jrb-03.jpg" width="100%" />
          </vx-card>
        </div>
        <div class="vx-col md:w-1/3 mb-base" v-if="(jrb == 'jrb-04' && isOpenPreview && isShowComment)" >
          <vx-card :title="jrb" >
            <img src="@/assets/images/jusetsu/screen-edit/jrb/M007-09/M007-09_jrb-04.jpg" width="100%" />
          </vx-card>
        </div>
      </Transition>
    <div class="vx-col mr-7 select flex-grow-width-make" :class="[!isShowComment && !isOpenPreview ? 'w-full' : !isShowComment ? 'w-57' : 'w-65']">
      <vx-card class=" preview-edit-screen">
          <div class="label-page mb-3">
            Ⅱ 取引条件に関する事項
          </div>
        <table>
            <tr>
                <td colspan="12" class="part-parent-name">
                  【(1).売買代金および交換差金以外に売主、買主間で授受される金銭の額】
                </td>
            </tr>
            <tr :id="`${arrayCommentId[0]}`">
              <td colspan="2"  style="border-right: none;">
                  売買代金
              </td>
              <td style="border-right: none; border-left:none;">
                <div class="items-center">
                  <vs-input @blur="baibaidaikin=formatIntegerAdvanced(baibaidaikin, true, 12); lostFocus, focusOut()" @focus="onFocus('baibaidaikin')"
                            type="text" class="w-full"
                            v-model="baibaidaikin"
                            name="baibaidaikin"
                            :maxlength="handleMaxLength(12, baibaidaikin)"></vs-input>
                  <span class="tooltip-custom" :class="addPadding('baibaidaikin')">{{showMaxlength(12, baibaidaikin, 'baibaidaikin', true)}}</span>
                  </div>
                <div class="text-warning" v-if="formValidation.baibaidaikin.isWarning">{{formValidation.baibaidaikin.message_warnning}}</div>
              </td>
              <td class="w-1/6" style="border-left:none;">
                  円
              </td>
            </tr>
            <tr v-if="jrb == 'jrb-02' || jrb == 'jrb-03' || jrb == 'jrb-04'">
                <td colspan="2" style="border-right: none;" :id="`${arrayCommentId[1]}`" >
                    （うち消費税等相当額
                </td>
                <td style="border-right: none; border-left:none;" class="w-1/2">
                  <div>
                    <vs-input @blur="uchishohizei_sotogaku=formatIntegerAdvanced(uchishohizei_sotogaku, true, 12); lostFocus, focusOut()" @focus="onFocus('uchishohizei_sotogaku')" type="text" class="w-auto"
                              v-model="uchishohizei_sotogaku"
                              name="uchishohizei_sotogaku"
                              :disabled= "!shohizei_hyoji"
                              :maxlength="handleMaxLength(12, uchishohizei_sotogaku)"></vs-input>
                    <span class="tooltip-custom" :class="addPadding('uchishohizei_sotogaku')">{{showMaxlength(12, uchishohizei_sotogaku, 'uchishohizei_sotogaku', true)}}</span>
                  </div>
                  <div class="text-warning" v-if="formValidation.uchishohizei_sotogaku.isWarning">{{formValidation.uchishohizei_sotogaku.message_warnning}}</div>
                </td>
                <td style="border-left:none;" class="w-1/6">
                    <div class="flex pt-2">
                        <span class="flex items-center">円)</span>
                        <vs-checkbox @input="lostFocus" @change="handleDeleteContentWhenClick" v-model="shohizei_hyoji">消費税表示</vs-checkbox>
                    </div>
                </td>
            </tr>
            <tr :id="`${arrayCommentId[2]}`">
                <td rowspan="3" class="w-1/6">
                1.
                </td>
                <td  class="w-1/6">
                    授受の目的
                </td>
                <td style="border-right: none; border-left:none; " class="w-1/2">
                    <label>手付金（売買代金の一部に充当します。)</label>
                </td>
                <td  style="border-left:none;" class="w-1/6">
                </td>
            </tr>
            <tr>
              <td  class="w-1/6">
                金額
              </td>
              <td style="border-left:none; border-right:none;">
                <div class="items-center">
                  <vs-input @blur="kingaku1=formatIntegerAdvanced(kingaku1, true, 12); lostFocus, focusOut()" @focus="onFocus('kingaku1')"
                            type="text" class="w-full"
                            v-model="kingaku1"
                            name="kingaku1"
                            :maxlength="handleMaxLength(12, kingaku1)"></vs-input>
                  <span class="tooltip-custom" :class="addPadding('kingaku1')">{{showMaxlength(12, kingaku1, 'kingaku1', true)}}</span>
                </div>
                <div class="text-warning" v-if="formValidation.kingaku1.isWarning">{{formValidation.kingaku1.message_warnning}}</div>  
              </td>
              <td class="w-1/6" style="border-left:none;">
                  円
              </td>
            </tr>
            <tr>
                <td  class="w-1/6">
                    備考
                </td>
                <td class="w-1/2" style="border-right: none; border-left:none;">
                    <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('biko1')" type="text" class="w-auto" v-model="biko1" maxlength="22"></vs-input>
                    <span class="tooltip-custom" :class="addPadding('biko1')">{{showMaxlength(22, biko1, 'biko1')}}</span>
                </td>
                <td class="w-1/6" style="border-left:none;">
                </td>
            </tr>
            <tr>
                <td rowspan="3" class="w-1/6">
                2.
                </td>
                <td  class="w-1/6">
                    授受の目的
                </td>
                <td class="w-1/2" style="border-right: none; border-left:none;">
                    <label>固定資産税等清算金</label>
                </td>
                <td class="w-1/6" style="border-left:none;">
                </td>
            </tr>
            <tr>
                <td  class="w-1/6">
                    金額
                </td>
                <td class="w-1/2" style="border-right: none; border-left:none;">
                <div>
                    <vs-input @blur="kingaku2=formatIntegerAdvanced(kingaku2, true, 12); lostFocus, focusOut()" @focus="onFocus('kingaku2')" type="text" class="w-auto"
                              v-model="kingaku2"
                              name="kingaku2"
                              :maxlength="handleMaxLength(12, kingaku2)"></vs-input>
                    <span class="tooltip-custom" :class="addPadding('kingaku2')">{{showMaxlength(12, kingaku2, 'kingaku2', true)}}</span>
                              </div>
                    <div class="text-warning" v-if="formValidation.kingaku2.isWarning">{{formValidation.kingaku2.message_warnning}}</div>  
                    <vs-checkbox @input="lostFocus"  class="p-1" v-model="hikiwatashiji_hiwari2" @change="Biko2()">引渡日日割り清算と備考に反映</vs-checkbox>
                </td>
                <td class="w-1/6 pb-10" style="border-left:none;">
                    円
                </td>
            </tr>
            <tr>
                <td  class="w-1/6">
                    備考
                </td>
                <td class="w-1/2" style="border-right: none; border-left:none;">
                  <!-- <v-select v-model="koteishisanzei_kisanbi"
                            name="koteishisanzei_kisanbi"
                            :options="koteishisanzei_kisanbi_options"
                            :reduce="option => option.value"
                            :clearable="false"
                            class="w-1/2"
                            style="margin-bottom: 8px;width: 200px;"
                            @input=" lostFocus();koteishisanzei()"
                            @change="koteishisanzei()">
                      <span slot="no-options">該当する選択肢がありません。</span>
                    </v-select> -->
                  <!-- <vs-input @blur="lostFocus" type="text" class="w-auto" v-model="biko2" maxlength="22"></vs-input> -->
                  <vs-input @blur="lostFocus, focusOut()" @focus="onFocus(`biko2`)" type="text" class="w-auto" v-model="biko2" maxlength="22"></vs-input>
                  <span class="tooltip-custom" :class="addPadding(`biko2`)">{{showMaxlength(22, biko2, `biko2`)}}</span>
                </td>
                <td class="w-1/6" style="border-left:none;">
                </td>
            </tr>
        </table>
        <div v-if=" jrb == 'jrb-03' || jrb == 'jrb-04'">
          <table>
            <tr >
                <td rowspan="3" class="w-1/6">
                3.
                </td>
                <td  class="w-1/6">
                    授受の目的
                </td>
                <td  class="w-1/2" style="border-right: none; border-left:none;">
                    <div>
                        <label>管理費等清算金</label>
                    </div>
                </td>
                <td class="w-1/6" style="border-left:none;">
                </td>
            </tr>
            <tr>
                <td  class="w-1/6">
                    金額
                </td>
                <td class="w-1/2" style="border-right: none; border-left:none;">
                    <vs-input @blur="kingaku3=formatIntegerAdvanced(kingaku3, true, 12); lostFocus, focusOut()" @focus="onFocus('kingaku3')" type="text" class="w-auto"
                              v-model="kingaku3"
                              :maxlength="handleMaxLength(12, kingaku3)"></vs-input>
                    <span class="tooltip-custom" :class="addPadding('kingaku3')">{{showMaxlength(12, kingaku3, 'kingaku3', true)}}</span>
                    <vs-checkbox @input="lostFocus"  class="p-1" v-model="hikiwatashiji_hiwari3" @change="Biko3()">引渡日日割り清算と備考に反映</vs-checkbox>
                </td>
                <td class="w-1/6 pb-10" style="border-left:none;">
                    円
                </td>
            </tr>
            <tr>
                <td  class="w-1/6">
                    備考
                </td>
                <td class="w-1/2" style="border-right: none; border-left:none;" >
                    <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('biko3')" type="text" class="w-auto" v-model="biko3" maxlength="22"></vs-input>
                    <span class="tooltip-custom" :class="addPadding('biko3')">{{showMaxlength(22, biko3, 'biko3')}}</span>
                </td>
                <td class="w-1/6" style="border-left:none;">
                </td>
            </tr>
          </table>
        </div>
        <div v-if=" jrb == 'jrb-03' || jrb == 'jrb-04'">
          <table class="w-full" v-for="(kinsen, index) in kinsen_gaku" :key="`kin-${index}`">
            <tr>
                <td rowspan="3" class="w-1/6">
                  <div class="flex">
                    <vs-checkbox @input="lostFocus" class="" v-model="kinsen.checkboxDelete" ></vs-checkbox>
                    <span>{{index + 4}}.</span>
                  </div>
                </td>
                <td  class="w-1/6">
                    授受の目的
                </td>
                <td class="w-1/2" style="border-right: none; border-left:none;">
                    <vs-input @blur="lostFocus, focusOut()" @focus="onFocus(`kinsen.jujunomokuteki.${index}`)" type="text" class="w-auto"  v-model="kinsen.jujunomokuteki" maxlength="21"></vs-input>
                    <span class="tooltip-custom" :class="addPadding(`kinsen.jujunomokuteki.${index}`)">{{showMaxlength(21, kinsen.jujunomokuteki, `kinsen.jujunomokuteki.${index}`)}}</span>
                </td>
                <td class="w-1/6" style="border-left:none;">
                </td>
            </tr>
            <tr>
                <td  class="w-1/6">
                    金額
                </td>
                <td class="w-1/2" style="border-right: none; border-left:none;">
                    <vs-input @blur="kinsen.kingaku=formatIntegerAdvanced(kinsen.kingaku, true, 12); lostFocus, focusOut()" @focus="onFocus(`kinsen.kingaku.${index}`)" type="text" class="w-auto"
                              v-model="kinsen.kingaku"
                              :maxlength="handleMaxLength(12, kinsen.kingaku)"></vs-input>
                    <span class="tooltip-custom" :class="addPadding(`kinsen.kingaku.${index}`)">{{showMaxlength(12, kinsen.kingaku, `kinsen.kingaku.${index}`, true)}}</span>
                    <vs-checkbox @input="lostFocus"  class="p-1" v-model="kinsen.hikiwatashiji_hiwari" @change="Biko(index)">引渡日日割り清算と備考に反映</vs-checkbox>
                </td>
                <td class="w-1/6 pb-10" style="border-left:none;">
                    円
                </td>
            </tr>
            <tr>
                <td  class="w-1/6">
                    備考
                </td>
                <td class="w-1/2" style="border-right: none; border-left:none;">
                    <vs-input @blur="lostFocus, focusOut()" @focus="onFocus(`kinsen.biko.${index}`)" type="text" class="w-auto" v-model="kinsen.biko" maxlength="22"></vs-input>
                    <span class="tooltip-custom" :class="addPadding(`kinsen.biko.${index}`)">{{showMaxlength(22, kinsen.biko, `kinsen.biko.${index}`)}}</span>
                </td>
                <td class="w-1/6" style="border-left:none;">
                </td>
            </tr>
        </table>
        </div>
        <div v-if=" jrb == 'jrb-01' || jrb == 'jrb-02'">
          <table class="w-full" v-for="(kinsen, index) in kinsen_gaku" :key="`kin-${index}`">
            <tr>
                <td rowspan="3" class="w-1/6">
                  <div class="flex">
                    <vs-checkbox @input="lostFocus" class="" v-model="kinsen.checkboxDelete" ></vs-checkbox>
                    <span>{{index + 3}}.</span>
                  </div>
                </td>
                <td  class="w-1/6">
                    授受の目的
                </td>
                <td class="w-1/2" style="border-right: none; border-left:none;">
                    <vs-input @blur="lostFocus, focusOut()" @focus="onFocus(`kinsen.jujunomokuteki.${index}`)" type="text" class="w-auto"  v-model="kinsen.jujunomokuteki" maxlength="21"></vs-input>
                    <span class="tooltip-custom" :class="addPadding(`kinsen.jujunomokuteki.${index}`)">{{showMaxlength(21, kinsen.jujunomokuteki, `kinsen.jujunomokuteki.${index}`)}}</span>
                </td>
                <td class="w-1/6" style="border-left:none;">
                </td>
            </tr>
            <tr>
                <td  class="w-1/6">
                    金額
                </td>
                <td class="w-1/2" style="border-right: none; border-left:none;">
                    <vs-input @blur="kinsen.kingaku=formatIntegerAdvanced(kinsen.kingaku, true, 12); lostFocus, focusOut()" @focus="onFocus(`kinsen.kingaku.${index}`)" type="text" class="w-auto" v-model="kinsen.kingaku"  
                              :maxlength="handleMaxLength(12, kinsen.kingaku)"></vs-input>
                    <span class="tooltip-custom" :class="addPadding(`kinsen.kingaku.${index}`)">{{showMaxlength(12, kinsen.kingaku, `kinsen.kingaku.${index}`, true)}}</span>
                    <vs-checkbox @input="lostFocus"  class="p-1" v-model="kinsen.hikiwatashiji_hiwari" @change="Biko(index)">引渡日日割り清算と備考に反映</vs-checkbox>
                </td>
                <td class="w-1/6 pb-10" style="border-left:none;">
                    円
                </td>
            </tr>
            <tr>
                <td class="w-1/6">
                    備考
                </td>
                <td class="w-1/2" style="border-right: none; border-left:none;">
                    <vs-input @blur="lostFocus, focusOut()" @focus="onFocus(`kinsen.biko.${index}`)" type="text" class="w-auto" v-model="kinsen.biko" maxlength="22"></vs-input>
                    <span class="tooltip-custom" :class="addPadding(`kinsen.biko.${index}`)">{{showMaxlength(22, kinsen.biko, `kinsen.biko.${index}`)}}</span>
                </td>
                <td class="w-1/6" style="border-left:none;">
                </td>
            </tr>
        </table>
        </div>
        <table>
            <tr>
                <td colspan="4">
                    <div class="flex justify-end">
                        <vs-button class="primary mr-4 btn-positive" :disabled="(kinsen_gaku.length >= 24 && ((jrb == 'jrb-01') || (jrb == 'jrb-02'))) || (kinsen_gaku.length >= 23 && ((jrb == 'jrb-03') || (jrb == 'jrb-04'))) " @click="add_kinsen(kinsen_gaku)">項目追加</vs-button>
                        <vs-button class="btn-positive" color="positive" type="filled" text-color="#7367F0" @click="callpopupDeleteForm1()">項目削除</vs-button>
                    </div>
                </td>
            </tr>
        </table>
        <table class="w-full">
          <tr> 
            <td rowspan="3" class="w-1/6">
              <div class="flex">
                <span class="text-left">「以下余白」の表示</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="flex items-center">
                <vs-checkbox v-model="jujusarerukinsennogaku_biko_matsubi_ikayohaku_hyoji" class="inline-flex"></vs-checkbox>
                <span class="ml-2">末尾に「以下余白」を表示する</span>
              </div>
            </td>
          </tr>
        </table>
        <table class="w-full">
          <tr> 
            <td rowspan="3" class="w-1/6">
              <div class="flex">
                <span class="text-left">黒点／ナンバリング表示</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="flex items-center">
                <vs-checkbox v-model="jujusarerukinsennogaku_biko_numbering" class="inline-flex"></vs-checkbox>
                <span class="ml-2">黒点／ナンバリングを表示する</span>
              </div>
            </td>
          </tr>
        </table>
        <table :id="`${arrayCommentId[3]}`">
          <draggable v-model="jujusarerukinsennogaku_biko" handle=".handle">
            <table class="w-full" v-for="(jujusarerukinsennogaku, index) in jujusarerukinsennogaku_biko" :key="`juju-${index}`">
              <tr>
                <td rowspan="4"  class="label-fix-length w-1/6">
                  <div class="flex">
                    <vs-checkbox @input="lostFocus" class="inline-flex" v-model="jujusarerukinsennogaku.checkboxDelete"></vs-checkbox>
                    <span class="pt-3 pr-2">備考 {{index +1 }}</span>
                    <div style="padding-right: 20px;" class="handle pt-3 cursor-default w-19">
                      <vx-tooltip text="この入力欄を移動" position="top" delay=".3s">
                        <DragBlackIcon />
                      </vx-tooltip>
                    </div>
                  </div>
                </td>
                <td style=" border-left:none; border-bottom:none;">
                  <div class="flex items-center w-full">
                    <BunshoTemplate v-model="jujusarerukinsennogaku.naiyo" screen="M007-09" />
                    <span class="p-4 text-sm">※備考への表示状況は重要事項説明書レイアウト画面にて確認してください</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="w-full" style=" border-left:none; border-top:none;" >
                  <vs-textarea @blur="focusOut()" @focus="onFocus(`jujusarerukinsennogaku.naiyo.${index}`)" rows="7" v-model="jujusarerukinsennogaku.naiyo" maxlength="3000"></vs-textarea>
                  <span class="tooltip-custom -mt-4" :class="addPadding(`jujusarerukinsennogaku.naiyo.${index}`)">{{showMaxlength(3000, jujusarerukinsennogaku.naiyo, `jujusarerukinsennogaku.naiyo.${index}`)}}</span>
                </td>
              </tr>
            </table>
          </draggable>
        </table>
        <table>
            <tr>
              <td colspan="4">
                <div class="flex justify-end">
                  <vs-button class="primary mr-4 btn-positive" @click="add_biko(jujusarerukinsennogaku_biko)" >項目追加</vs-button>
                  <vs-button class="btn-positive" color="positive" type="filled" text-color="#7367F0" @click="callpopupDeleteForm2()">項目削除</vs-button>
                </div>

              </td>
            </tr>
        </table>
      </vx-card>

      <footer-button @cancel="popupActiveCancelForm = true" @save="checkSave"></footer-button>


      <!-- Popup delete -->
      <vs-popup
        class="holamundo"
        title="削除"
        :active.sync="popupDeleteForm1"
        :button-close-hidden="true"
      >
        <p class="my-4 font-bold text-lg">
          選択された項目を削除します。よろしいですか？
        </p>
        <div class="flex justify-end">
          <vs-button class="mr-8 btn-positive btn-yes" @click="handleDeletekinsen"
            >はい</vs-button
          >
          <vs-button @click="popupDeleteForm1 = false" class="btn-positive" color="positive" type="filled" text-color="#7367F0"
            >いいえ</vs-button
          >
        </div>
      </vs-popup>
      <vs-popup
        class="holamundo"
        title="削除"
        :active.sync="popupDeleteForm2"
        :button-close-hidden="true"
      >
        <p class="my-4 font-bold text-lg">
          選択された項目を削除します。よろしいですか？
        </p>
        <div class="flex justify-end">
          <vs-button class="mr-8 btn-positive btn-yes" @click="handleDeleteBiko"
            >はい</vs-button
          >
          <vs-button @click="popupDeleteForm2 = false" class="btn-positive" color="positive" type="filled" text-color="#7367F0"
            >いいえ</vs-button
          >
        </div>
      </vs-popup>

      <!-- Popup Cancel -->
      <vs-popup
        class="holamundo"
        title="キャンセル"
        :active.sync="popupActiveCancelForm"
        :button-close-hidden="true"
      >
        <p class="my-4 font-bold text-lg">
          {{message_cancel}}
        </p>
        <div class="flex justify-end">
          <vs-button class="mr-8 btn-positive btn-yes" @click="handleCancelSavejrb"
            >はい</vs-button
          >
          <vs-button @click="popupActiveCancelForm = false" class="btn-positive" color="positive" type="filled" text-color="#7367F0"
            >いいえ</vs-button
          >
        </div>
      </vs-popup>
      <!-- Popup Save -->
      <vs-popup
        class="holamundo"
        title="保存"
        :active.sync="popupActiveSaveForm"
        :button-close-hidden="true"
      >
        <p class="my-4 font-bold text-lg">
          {{messageSaveForm}}
        </p>
        <div class="flex justify-end">
          <vs-button class="mr-8 btn-positive btn-yes" @click="handleSavejrb"
            >はい</vs-button
          >
          <vs-button @click="popupActiveSaveForm = false" class="btn-positive" color="positive" type="filled" text-color="#7367F0"
            >いいえ</vs-button
          >
        </div>
      </vs-popup>
    </div>
    <vx-card class="vx-col comment-frame" id="closeCommentSiderPattern" :class="isShowComment ? 'closeComment': 'showComment'">
      <Comment @showHightlightInPage="handleShowHightlightInPage" @commentData="getArrayHighlight" :pattern="getJrbParttern" :screenCode="screenCode='M007-09'"/>
    </vx-card>
    </div>
</template>
<script>
import vSelect from 'vue-select'
import json from '../jsons-data/options.json'
import _ from 'lodash'
import BunshoTemplate from './components/BunshoTemplate.vue'
import FooterButton from './components/FooterButton.vue'
import hanyo_code from '../jsons-data/hanyo_code.json'
import itaku_sample from '../jsons-data/itaku_sample_data.json'
import { SAVE_JRB_M007_09, SAVE_EDIT_MODE, SAVE_KEIYAKU } from '@/store/modules/keiyaku/actions.js'
import { MESSAGE } from '../constant/message_code'
import routeIfCodeNull from '@/mixins/routeIfCodeNull'
import utilitiesMethods from '@/mixins/utilitiesMethods'
import { SAVE_BPM, SAVE_BSC } from '../store/modules/keiyaku/actions'
import LeftPreviewSlider from './components/LeftPreviewSlider.vue'
import Comment from './comment'
import { M007_09_jrb01Highlight, M007_09_jrb02_04Highlight } from '../constant/highlight'
import highlighter from '../mixins/highlighter'
import draggable from 'vuedraggable'
import DragBlackIcon from '@/assets/images/icons/DragBlackIcon.vue'

export default {
  name: 'jrb-1',
  mixins: [routeIfCodeNull, utilitiesMethods, highlighter],
  components: {
    vSelect,
    BunshoTemplate,
    FooterButton,
    LeftPreviewSlider,
    DragBlackIcon,
    draggable,
    Comment
  },

  data() {
    return {
      jujusarerukinsennogaku_biko_matsubi_ikayohaku_hyoji: true,
      jujusarerukinsennogaku_biko_numbering: true,
      arrayCommentId: [],
      arrayHighlightId: [],
      isShowComment: true,
      isOpenPreview: true,
      // Predified Value
      hanyo: hanyo_code,
      itaku_sample_data: itaku_sample,
      //data
      baibaidaikin : null,
      uchishohizei_sotogaku : null,
      shohizei_hyoji : false,

      kingaku1 : null,
      hikiwatashiji_hiwari1 : false,
      biko1 : '',

      kingaku2 : null,
      hikiwatashiji_hiwari2 : false,
      biko2 : '',

      kingaku3 : null,
      hikiwatashiji_hiwari3 : false,
      biko3 : '',

      kinsen_gaku : [],
      jujusarerukinsennogaku_biko:[
        {
          checkboxDelete: false,
          naiyo: ''
        }
      ],
      // koteishisanzei_kisanbi: '', 
      // koteishisanzei_kisanbi_options: [],
      myJson: json,

      //popupDelete
      popupDeleteForm1: false,
      popupDeleteForm2: false,
      //popupCancel
      popupActiveCancelForm: false,
      //popupSave
      popupActiveSaveForm: false,
      message_cancel: MESSAGE.M1008,
      messageSaveForm: '',
      formValidation: {
        baibaidaikin: {
          patterns: ['jrb-01', 'jrb-02', 'jrb-03', 'jrb-04'],
          isWarning: false,
          message_warnning: MESSAGE.E8051,
          warning: true
        },
        uchishohizei_sotogaku: {
          patterns: ['jrb-02', 'jrb-03', 'jrb-04'],
          isWarning: false,
          message_warnning: MESSAGE.E8051,
          warning: () => {
            return !this.uchishohizei_sotogaku && this.shohizei_hyoji === true
          }
        },
        kingaku1: {
          patterns: ['jrb-01', 'jrb-02', 'jrb-03', 'jrb-04'],
          isWarning: false,
          message_warnning: MESSAGE.E8051,
          warning: true
        },
        kingaku2: {
          patterns: ['jrb-01', 'jrb-02', 'jrb-03', 'jrb-04'],
          isWarning: false,
          message_warnning: MESSAGE.E8051,
          warning: () => {
            return !this.kingaku2 && this.hikiwatashiji_hiwari2 === true
          }
        }
      },
      hasWarning : false,
      checkValidate: false
    }
  },
  computed: {
    getStateShowComment() {
      return this.$store.getters.getStateShowComment
    },
    getLeftPreviewSliderStatus() {
      return this.$store.getters.getLeftPreviewSliderStatus
    },
    shakuchimensekiSum() {
      return this.shakuchikenTochiInputs.map(item => item.chiseki).reduce((a, b) => +a + +b, 0)
    },
    tochi_gokeimensekiSum() {
      return this.tochiInputs.map(item => item.chiseki).reduce((a, b) => +a + +b, 0)
    },
    shikikentochi_mensekiSum() {
      return this.shikikenmokutekitochiInputs.map(item => item.chiseki).reduce((a, b) => +a + +b, 0)
    },
    teikishakuchi_mensekiSum() {
      return this.teikiShakuchikenTochiInputs.map(item => item.chiseki).reduce((a, b) => +a + +b, 0)
    },
    jrb() {
      try {
        return this.$store.getters.pattern.jusetsu.jrb
      } catch (e) {
        return null
      }
    },
    bpmData() {
      return _.cloneDeep(_.get(this.$store.getters.keiyaku, 'baikei.bpm', null))
    },
    besData() {
      return _.cloneDeep(_.get(this.$store.getters.keiyaku, 'jusetsu.jrb07_09', null))
    },
    bscData() {
      return _.cloneDeep(_.get(this.$store.getters.keiyaku, 'baikei.bsc', null))
    }

  },
  mounted() {
    this.getStyleForEditScreen()
    this.handleGetCommentId()
    this.isShowComment = this.getStateShowComment
    this.isOpenPreview = this.getLeftPreviewSliderStatus
    // this.koteishisanzei_kisanbi_options = this.myJson._55.values
    // Get data from Local storage
    if(this.jrb === 'jrb-03' || this.jrb === 'jrb-04') {
      this.kinsen_gaku =  [
        {
          jujunomokuteki : '',
          kingaku : '',
          hikiwatashiji_hiwari : false,
          biko : '',
          checkboxDelete: false
        },
        {
          jujunomokuteki : '',
          kingaku : '',
          hikiwatashiji_hiwari : false,
          biko : '',
          checkboxDelete: false
        }
      ]
    } else {
      this.kinsen_gaku =  [
        {
          jujunomokuteki : '',
          kingaku : '',
          hikiwatashiji_hiwari : false,
          biko : '',
          checkboxDelete: false
        },
        {
          jujunomokuteki : '',
          kingaku : '',
          hikiwatashiji_hiwari : false,
          biko : '',
          checkboxDelete: false
        },
        {
          jujunomokuteki : '',
          kingaku : '',
          hikiwatashiji_hiwari : false,
          biko : '',
          checkboxDelete: false
        }
      ]
    }


    if(this.besData) {
      const besData = this.besData
      this.jujusarerukinsennogaku_biko_matsubi_ikayohaku_hyoji = besData.jujusarerukinsennogaku_biko_matsubi_ikayohaku_hyoji === undefined ? true : besData.jujusarerukinsennogaku_biko_matsubi_ikayohaku_hyoji
      this.jujusarerukinsennogaku_biko_numbering = besData.jujusarerukinsennogaku_biko_numbering === undefined ? true : besData.jujusarerukinsennogaku_biko_numbering
      this.baibaidaikin = besData.baibaidaikin
      this.uchishohizei_sotogaku = besData.uchishohizei_sotogaku
      this.shohizei_hyoji = besData.shohizei_hyoji

      this.kingaku1 = besData.kingaku1
      this.hikiwatashiji_hiwari1 = besData.hikiwatashiji_hiwari1
      this.biko1 = besData.biko1

      this.kingaku2 = besData.kingaku2
      this.hikiwatashiji_hiwari2 = besData.hikiwatashiji_hiwari2
      this.biko2 = besData.biko2

      this.kingaku3 = besData.kingaku3
      this.hikiwatashiji_hiwari3 = besData.hikiwatashiji_hiwari3
      this.biko3 = besData.biko3
      // this.koteishisanzei_kisanbi = besData.koteishisanzei_kisanbi

      if (Array.isArray(besData.kinsen_gaku)) {
        this.kinsen_gaku = besData.kinsen_gaku.map(e => {
          return {
            jujunomokuteki : e.jujunomokuteki,
            kingaku : e.kingaku,
            hikiwatashiji_hiwari : e.hikiwatashiji_hiwari,
            biko : e.biko,
            checkboxDelete: false
          }
        })
      }
      if (Array.isArray(besData.jujusarerukinsennogaku_biko)) {
        this.jujusarerukinsennogaku_biko = besData.jujusarerukinsennogaku_biko.map(e => {
          return {
            checkboxDelete: false,
            naiyo: e
          }
        })
      }
      this.reformatFields()
      this.kinsen_gaku.forEach((ele, index) => {
        this.kingakuFormat(index)
      })
    }
    

    // if(this.biko2.includes('起算日は１月１日')) {
    //   this.koteishisanzei_kisanbi = this.myJson._55.values[1].value
    // } else if(this.biko2.includes('起算日は４月１日')) {
    //   this.koteishisanzei_kisanbi = this.myJson._55.values[2].value
    // } else {
    //   this.koteishisanzei_kisanbi = this.myJson._55.values[0].value
    // }
    
    const editMode = _.get(this.$store.getters.editMode, 'jrb07_09', false)
    if (editMode) {
      this.validateWarning()
    }
    //this.koteishisanzei()
  },
  watch: {
    '$store.getters.getStateShowComment' (val) {
      this.isShowComment = val
    },
    '$store.getters.getLeftPreviewSliderStatus' (val) {
      this.isOpenPreview = val
    }
  },
  methods: {
    // koteishisanzei() {
    //   if(this.biko2 && this.biko2.includes('undefined')) {
    //     this.biko2 = this.biko2.replaceAll('undefined', '')
    //     this.biko2 = this.biko2.replaceAll(' ', '')
    //     this.biko2 = this.biko2.replaceAll('　', '')
    //   }
    //   if(!this.biko2) {
    //     this.biko2 = this.koteishisanzei_kisanbi
    //   } else if(!this.biko2.includes('起算日は１月１日') && !this.biko2.includes('起算日は４月１日')) {
    //     this.biko2 = `${this.biko2}　${this.koteishisanzei_kisanbi}`
    //   } else if(this.koteishisanzei_kisanbi === '起算日は１月１日') {
    //     this.biko2 = this.biko2.replaceAll('起算日は４月１日', '起算日は１月１日')
    //   } else if(this.koteishisanzei_kisanbi === '起算日は４月１日') {
    //     this.biko2 = this.biko2.replaceAll('起算日は１月１日', '起算日は４月１日')
    //   } else if(this.koteishisanzei_kisanbi === '') {
    //     this.biko2 = this.biko2.replaceAll('起算日は１月１日', '')
    //     this.biko2 = this.biko2.replaceAll('起算日は４月１日', '')
    //     this.biko2 = this.biko2.replaceAll(' ', '')
    //     this.biko2 = this.biko2.replaceAll('　', '')
    //   }
      
    // },
    Biko2() {
      // this.biko2 = this.biko2.replaceAll(' ', '')
      // this.biko2 = this.biko2.replaceAll('　', '')
      // if(this.hikiwatashiji_hiwari2 === true && this.biko2) {
      //   this.biko2 = `引き渡し時日割清算　${this.biko2}`
      // }else if(this.hikiwatashiji_hiwari2 === true && !this.biko2) {
      //   this.biko2 = '引き渡し時日割清算'
      // }else if(this.hikiwatashiji_hiwari2 === false) {
      //   this.biko2 = this.biko2.replaceAll('引き渡し時日割清算', '')
      // }
      if(this.hikiwatashiji_hiwari2 === true) {
        this.biko2 = '引き渡し時日割清算'
      }else{
        this.biko2 = ''
      }
    },
    Biko3() {
      if(this.hikiwatashiji_hiwari3 === true) {
        this.biko3 = '引き渡し時日割清算'
      }else{
        this.biko3 = ''
      }
    },
    Biko(index) {
      if(this.kinsen_gaku[index].hikiwatashiji_hiwari === true) {
        this.kinsen_gaku[index].biko = '引き渡し時日割清算'
      }else{
        this.kinsen_gaku[index].biko  = ''
      }
    },

    add_kinsen(kinsen_gaku) {
      kinsen_gaku.push({
        checkboxDelete: false,
        jujunomokuteki: '',
        kingaku: null,
        hikiwatashiji_hiwari : false,
        biko : ''
      }
      )
    },
    callpopupDeleteForm1() {
      let flag = true
      this.kinsen_gaku.forEach(element => {
        if(element.checkboxDelete) {
          this.popupDeleteForm1 = true
          flag = false
        }
      })

      if(flag) {
        this.$toasted.error('項目が選択されていません。')

      }
    },
    handleDeletekinsen() {
      this.kinsen_gaku = this.kinsen_gaku.length > 0 ? this.kinsen_gaku.filter(v => v.checkboxDelete === false) : this.kinsen_gaku
      if(this.kinsen_gaku.length === 0) {

        this.add_kinsen(this.kinsen_gaku)
      }
      this.popupDeleteForm1 = false
    },
    add_biko(jujusarerukinsennogaku_biko) {
      jujusarerukinsennogaku_biko.push({
        checkboxDelete: false,
        naiyo: ''
      }
      )
    },
    callpopupDeleteForm2() {
      let flag = true
      this.jujusarerukinsennogaku_biko.forEach(element => {
        if(element.checkboxDelete) {
          this.popupDeleteForm2 = true
          flag = false
        }
      })
      if(flag) {
        this.$toasted.error('項目が選択されていません。')

      }
    },
    handleDeleteBiko() {
      this.jujusarerukinsennogaku_biko = this.jujusarerukinsennogaku_biko.length > 0 ? this.jujusarerukinsennogaku_biko.filter(v => v.checkboxDelete === false) : this.jujusarerukinsennogaku_biko
      if(this.jujusarerukinsennogaku_biko.length === 0) {
        this.add_biko(this.jujusarerukinsennogaku_biko)
      }
      this.popupDeleteForm2 = false
    },
    handleCancelSavejrb() {
      this.handleSaveCountLocal()
      this.popupActiveCancelForm = false
      setTimeout(() => {
        this.$router.push({name: 'jusetsu-m006-01'})
      }, 200)
    },
    numberKeypress($event) {
      const value = $event.key
      const regex = /^[0-9]*,*$/
      if (!value.match(regex)) {
        $event.preventDefault()
        return false
      }
    },
    numberFormat(field, comma = true) {
      let text = field && this[field] ? this[field] : ''
      text = text.toString().replaceAll(',', '')
      if (comma) {
        this[field] = text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      } else {
        this[field] = text
      }
    },
    kingakuFormat(index) {
      let text = this.kinsen_gaku[index].kingaku ? this.kinsen_gaku[index].kingaku : ''
      text = text.toString().replaceAll(',', '')
      this.kinsen_gaku[index].kingaku = text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    reformatFields(comma = true) {
      const formatFields = []
      formatFields.forEach(field => {
        this.numberFormat(field, comma)
      })
    },
    handleDeleteContentWhenClick() {
      if(this.shohizei_hyoji === false) {
        this.uchishohizei_sotogaku = ''
      }
    },
    handleSavejrb() {
      const handle = () => {
        this.reformatFields(false)
        const jrb_09 = {
          jujusarerukinsennogaku_biko_matsubi_ikayohaku_hyoji: this.jujusarerukinsennogaku_biko_matsubi_ikayohaku_hyoji,
          jujusarerukinsennogaku_biko_numbering: this.jujusarerukinsennogaku_biko_numbering,
          baibaidaikin: this.baibaidaikin,
          uchishohizei_sotogaku: this.uchishohizei_sotogaku,
          shohizei_hyoji: this.shohizei_hyoji,
          kinsen_gaku: this.kinsen_gaku.map(ele => {
            ele.kingaku = ele.kingaku
            return ele
          }),
          kingaku1: this.kingaku1,
          hikiwatashiji_hiwari1: this.hikiwatashiji_hiwari1,
          biko1: this.biko1,
          kingaku2: this.kingaku2,
          hikiwatashiji_hiwari2: this.hikiwatashiji_hiwari2,
          biko2: this.biko2,
          kingaku3: this.kingaku3,
          hikiwatashiji_hiwari3: this.hikiwatashiji_hiwari3,
          biko3: this.biko3,
          // koteishisanzei_kisanbi: this.koteishisanzei_kisanbi,
          jujusarerukinsennogaku_biko: this.jujusarerukinsennogaku_biko.map(e => e.naiyo)
        }
        const bpm = {
          baibaidaikin_sogaku: this.baibaidaikin,
          tetsukekin_teiketsu_haraigaku: this.kingaku1,
          baibaidaikin_shohizeisotogaku: this.uchishohizei_sotogaku,
          baibaidaikin_shohizeihyoji: this.shohizei_hyoji
        }
        if(this.kingaku1) {
          bpm.baibaidaikin_ikkatsukessai = false
        }
        const bsc = {}
        // if(this.koteishisanzei_kisanbi === this.myJson._55.values[0].value) {
        //   bsc.seisankijunbi = null
        // }else if (this.koteishisanzei_kisanbi === this.myJson._55.values[1].value) {
        //   bsc.seisankijunbi = '0'
        // }else if (this.koteishisanzei_kisanbi === this.myJson._55.values[2].value) {
        //   bsc.seisankijunbi = '1'
        // }
        const bscData = _.merge(this.bscData, bsc)
        const bpmData = _.merge(this.bpmData, bpm)
        this.$store.dispatch(SAVE_JRB_M007_09, jrb_09).then(() => {
          this.$store.dispatch(SAVE_EDIT_MODE, {'jrb07_09': true})
          this.$store.dispatch(SAVE_BPM, bpmData)
          this.$store.dispatch(SAVE_BSC, bscData)
          this.$store.dispatch(SAVE_KEIYAKU).then(() => {
            this.popupActiveSaveForm = false
            setTimeout(() => {
              this.$router.push({name: 'jusetsu-m006-01'})
            }, 200)
          })
        })
      }
      this.handleCheckCount(handle)
      this.popupActiveSaveForm = false
    },
    highlight(key, isHighlight = true, eleIndex = null) {
      if (eleIndex === null) {
        // selectbox
        if (isHighlight) {
          $(`.v-select[name='${key}']`).find('.vs__dropdown-toggle').css({'background-color': 'rgb(255 197 54 / 60%)'})
        } else {
          $(`.v-select[name='${key}']`).find('.vs__dropdown-toggle').css({'background-color': 'inherit'})
        }
        // radiobox
        $('.con-vs-radio').each((idx, el) => {
          if ($(el).find(`input[name='${key}']`).length) {
            if (isHighlight) {
              $(el).find('span.vs-radio--borde').css({'border-color': '#eea840'})
            } else {
              $(el).find('span.vs-radio--borde').css({'border-color': '#c8c8c8'})
            }
          }
        })
        // checkbox
        $('.con-vs-checkbox').each((idx, el) => {
          if ($(el).find(`input[vs-name='${key}']`).length) {
            if (isHighlight) {
              $(el).find('span.vs-checkbox').css({'border-color': '#eea840'})
            } else {
              $(el).find('span.vs-checkbox').css({'border-color': '#c8c8c8'})
            }
          } else if ($(el).find(`input[name='${key}']`).length) {
            if (isHighlight) {
              $(el).find('span.vs-checkbox').css({'border-color': '#eea840'})
            } else {
              $(el).find('span.vs-checkbox').css({'border-color': '#c8c8c8'})
            }
          }
        })
        // vs-input
        const inputEl = $(`input[name='${key}']`)
        if (isHighlight) {
          inputEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
        } else {
          inputEl.css({'background-color': 'inherit'})
        }
        // vs-textarea
        const textareaEl = $(`textarea[name='${key}']`)
        if (isHighlight) {
          textareaEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
        } else {
          textareaEl.css({'background-color': 'inherit'})
        }
        // datepicker
        const selectEl = $(`div[datepicker='${key}']`).find('.vs__dropdown-toggle')
        const yearEl = $(`div[datepicker='${key}']`).find('input[name="year"]')
        const monthEl = $(`div[datepicker='${key}']`).find('input[name="month"]')
        const dayEl = $(`div[datepicker='${key}']`).find('input[name="day"]')
        if (isHighlight) {
          selectEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
          yearEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
          monthEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
          dayEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
        } else {
          selectEl.css({'background-color': 'inherit'})
          yearEl.css({'background-color': 'inherit'})
          monthEl.css({'background-color': 'inherit'})
          dayEl.css({'background-color': 'inherit'})
        }
      } else {
        // selectbox
        const selectboxEl = $(`.v-select[name='${key}']`)
        if (selectboxEl.length) {
          if (isHighlight) {
            $(selectboxEl[eleIndex]).find('.vs__dropdown-toggle').css({'background-color': 'rgb(255 197 54 / 60%)'})
          } else {
            $(selectboxEl[eleIndex]).find('.vs__dropdown-toggle').css({'background-color': 'inherit'})
          }
        }
        // radiobox
        $('.con-vs-radio').each((idx, el) => {
          const radioEl = $(el).find(`input[name='${key}']`)
          if (radioEl.length && $(radioEl[eleIndex]).length) {
            if (isHighlight) {
              $(radioEl[eleIndex]).find('span.vs-radio--borde').css({'border-color': '#eea840'})
            } else {
              $(radioEl[eleIndex]).find('span.vs-radio--borde').css({'border-color': '#c8c8c8'})
            }
          }
        })
        // vs-input
        const inputEl = $(`input[name='${key}']`)
        if (inputEl.length) {
          if (isHighlight) {
            $(inputEl[eleIndex]).css({'background-color': 'rgb(255 197 54 / 60%)'})
          } else {
            $(inputEl[eleIndex]).css({'background-color': 'inherit'})
          }
        }
        // vs-textarea
        const textareaEl = $(`textarea[name='${key}']`)
        if (textareaEl.length) {
          if (isHighlight) {
            $(textareaEl[eleIndex]).css({'background-color': 'rgb(255 197 54 / 60%)'})
          } else {
            $(textareaEl[eleIndex]).css({'background-color': 'inherit'})
          }
        }

        // datepicker
        if ($(`div[datepicker='${key}']`).length) {
          const selectEl = $(`div[datepicker='${key}']`)[eleIndex].find('.vs__dropdown-toggle')
          const yearEl = $(`div[datepicker='${key}']`)[eleIndex].find('input[name="year"]')
          const monthEl = $(`div[datepicker='${key}']`)[eleIndex].find('input[name="month"]')
          const dayEl = $(`div[datepicker='${key}']`)[eleIndex].find('input[name="day"]')
          if (isHighlight) {
            selectEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
            yearEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
            monthEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
            dayEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
          } else {
            selectEl.css({'background-color': 'inherit'})
            yearEl.css({'background-color': 'inherit'})
            monthEl.css({'background-color': 'inherit'})
            dayEl.css({'background-color': 'inherit'})
          }
        }
      }
    },
    validateWarning() {
      const context = this
      this.hasWarning = false
      Object.keys(this.formValidation).forEach(key => {
        this.formValidation[key].isWarning = false
        if (!this.formValidation[key].patterns || !this.formValidation[key].patterns.length
          || this.formValidation[key].patterns.includes(this.jrb)) {
          // ARRAY
          if (this.formValidation[key].elements) {
            this.formValidation[key].elements.forEach((child, idx) => {
              Object.keys(child).forEach(childKey => {
                if (typeof (context.formValidation[key].elements[idx][childKey].warning) === 'function' && this.formValidation[key].elements[idx][childKey].warning(idx)) {
                  context.formValidation[key].elements[idx][childKey].isWarning = true
                  context.highlight(childKey, true, idx)
                  context.hasWarning = true
                  context.messageWhenHanei = MESSAGE.M1017
                } else if (typeof (context.formValidation[key].elements[idx][childKey].warning) !== 'function'
                  && (context[key][idx][childKey] === null || context[key][idx][childKey] === undefined
                  || context[key][idx][childKey] === '' || context[key][idx][childKey] === false
                  || context[key][idx][childKey] === '　')) {
                  context.formValidation[key].elements[idx][childKey].isWarning = true
                  context.highlight(childKey, true, idx)
                  context.hasWarning = true
                  context.messageWhenHanei = MESSAGE.M1017
                } else {
                  context.formValidation[key].elements[idx][childKey].isWarning = false
                  context.highlight(childKey, false, idx)
                }
              })
            })
          } else if (typeof (this.formValidation[key].warning) === 'function' && this.formValidation[key].warning()) {
            this.formValidation[key].isWarning = true
            this.hasWarning = true
            this.highlight(key)
            this.messageWhenHanei = MESSAGE.M1017
          } else if (typeof (this.formValidation[key].warning) !== 'function' && this.formValidation[key].warning
            && (this[key] === null || this[key] === undefined || this[key] === '' || this[key] === false || this[key] === '　')) {
            this.formValidation[key].isWarning = true
            this.highlight(key)
            this.hasWarning = true
            this.messageWhenHanei = MESSAGE.M1017
          } else {
            this.highlight(key, false)
          }
        }
      })
      this.checkValidate = true
      return this.hasWarning
    },
    validateError() {
      const hasError = false
      // TODO
      return hasError
    },
    async checkSave() {
      const hasError = await this.validateError()
      if (hasError) {
        return
      }
      const hasWarning = await this.validateWarning()
      if (hasWarning) {
        this.messageSaveForm = MESSAGE.M1017
      }else {
        this.messageSaveForm = MESSAGE.M1007
      }
      this.popupActiveSaveForm = true
    },
    lostFocus() {
      if (this.checkValidate === true) {
        this.validateWarning()
      }
    },
    focusOut() {
      this.currentFocus = 0
      this.lostFocus()
    },
    getArrayHighlight(data) {
      const idElement = []
      const block_list = data.block_list
      block_list.forEach(item => {
        item.part_list.map(ele => {
          if(!ele.label_flg) {
            idElement.push(ele.id_element)
          }
        })
      })
      this.arrayHighlightId = idElement.filter(item => item.includes('jrb'))
    },
    handleGetCommentId() {
      let jrbPatternHighlight = []
      const code = +this.$store.getters.code
      switch (this.jrb) {
      case 'jrb-01':
        jrbPatternHighlight = M007_09_jrb01Highlight
        this.index = 0
        break
      case 'jrb-02':
        jrbPatternHighlight = M007_09_jrb02_04Highlight
        this.index = 56
        break
      case 'jrb-03':
        jrbPatternHighlight = M007_09_jrb02_04Highlight
        this.index = 68
        break
      case 'jrb-04':
        jrbPatternHighlight = M007_09_jrb02_04Highlight
        this.index = 68
        break
      default:
        break
      }
      const jrbHighlight = jrbPatternHighlight.map(item => {
        if(item) {
          this.index = this.index + 1
          if(this.jrb === 'jrb-01') {
            if(code === 21 || code === 22 || code === 23) {
              item = `${this.jrb}-05-${this.index}`
            } else if(code === 31 || code === 32 || code === 33) {
              item = `${this.jrb}-09-${this.index}`
            } else {
              item = `${this.jrb}-01-${this.index}`
            }
          } else {
            item = `${this.jrb}-${this.index}`
          }
        }
        return item
      })
      this.arrayCommentId = jrbHighlight
    },
    handleShowHightlightInPage(highlight) {
      const idHightlighted = this.arrayHighlightId
      this.handleShowHightlightInPageMixin(highlight, idHightlighted)
    }
  }
}

</script>

<style scoped>
.color-message-warnning {
    color: orange;
  }
.jrb {
  font-weight: bold;
}
.input {
  width:auto;
}


.sytle-button {
  display: flex;
  justify-content: flex-end;
  margin: 30px;
  gap: 30px;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
  border-radius:0px ;
}
td {
  font-size: 0.85rem;
  font-weight: 900;
}

.table-out {
  margin: 10px 0px;
  border: 2px solid rgb(201, 198, 198);
  border-radius: 5px;
  border-collapse: collapse;
}

.m-auto-top-bottom {
  margin: auto 0 ;
}

.col-title {
  color: white;
  background-color: #80808069;
  border-radius: 0px;
}

.con-exemple-prompt{
  padding: 10px;
  padding-bottom: 0px;
}

.itaku-dialog td {
  font-weight: 400;
}

.itaku-dialog th {
  text-align: center;
}

.mtb-10{
  margin: 10px 0;
}
.btn-positive {
  border: 1px solid #7367F0;
}
.baikei-transition-enter-active {
  transition: all 0.25s ease-out;
}

.baikei-transition-leave-active {
  transition: all 0.25s ease-in;
}

.baikei-transition-enter,
.baikei-transition-leave-to {
  transform: translateX(-50px);
  opacity: 0;
  width: 0% !important;
}
.flex-grow-width-make {
  flex-grow: 1;
  flex-basis: 57%;
  min-width: 57%;
}
.preview-edit-screen {
  overflow: scroll;
  height: 620px;
  margin-top: 0.75rem;
}
.comment-frame {
  overflow: scroll;
  height: 620px;
  margin-top: 0.75rem;

}
.w-57 {
  width: 56%;
}
.w-65 {
  width: 65%;
}
</style>
